import {EmergencyType} from 'app/shared/model/enumerations/emergency-type.model';
import {FollowupType} from "app/shared/model/enumerations/followup-type.model";
import { IFollowup } from './followup.model';

export interface ICondition {
  id?: string;
  followupType?: FollowupType;
  emergencyType?: EmergencyType;
  enFollowup?: string;
  stFollowup?: string;
  countryId?: string;
  isActive?:boolean;
  isCondition?:boolean;
  isAlive?:boolean;
  isDelivered?:boolean;
  parentId?: string;
  parent?: IFollowup;
}

export const defaultValue: Readonly<ICondition> = {};
